/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, isVariable } from '../../../../Fct/generics/FctParams';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
export var SimpleTransfer = createPlugin({
    protocol: 'ERC20',
    type: 'ACTION',
    method: 'transfer',
    name: 'simpleTransfer',
    falseMeansFail: true,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'erc20',
                    options: getSupportedTokens({ chainId: chainId }),
                }),
                methodParams: {
                    from: new FctAddress({}),
                    to: new FctAddress({}),
                    amount: new FctValue({ destination: 'wei_amount' }),
                },
            },
            output: {},
        });
    },
    overrideSetMethodParams: function (_a) {
        var input = _a.input;
        return function (params, method) {
            if (method === 'transferFrom') {
                Object.keys(input.methodParams).forEach(function (key, i) {
                    var paramKey = key;
                    input.methodParams[paramKey].value = params[i];
                });
            }
            if (method === 'transfer') {
                input.methodParams.to.value = params[0];
                input.methodParams.amount.value = params[1];
            }
        };
    },
    getSubscribtions: function (_a) {
        var setMethod = _a.setMethod, vaultAddress = _a.vaultAddress;
        return [
            {
                callback: function (params) {
                    if (!params)
                        return;
                    var from = params.methodParams.from;
                    var address = from === null || from === void 0 ? void 0 : from.value;
                    if (address && vaultAddress && vaultAddress.toLowerCase() === address.toLowerCase()) {
                        from.virtual = true;
                        setMethod('transfer');
                        return;
                    }
                    from.virtual = false;
                    setMethod('transferFrom');
                    return;
                },
                id: 'set_method_name',
            },
        ];
    },
    requiredApprovals: function (params, _chainId, _walletAddress, vaultAddress, _p, _m, isEstimation) {
        var to = params.to, _a = params.methodParams, amount = _a.amount, from = _a.from;
        if (!vaultAddress)
            return [];
        var address = from.value;
        if (vaultAddress && vaultAddress.toLowerCase() === address.toLowerCase())
            return [];
        var value = amount.value;
        if (isEstimation && isVariable(value) && typeof amount.estimatedValue === 'string') {
            value = amount.estimatedValue;
        }
        if (!value)
            return [];
        return [
            {
                to: to.value,
                from: from.value,
                params: { spender: vaultAddress, amount: value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    assetFlow: function (params) {
        var to = params.to, _a = params.methodParams, amount = _a.amount, from = _a.from, receiver = _a.to;
        if (!from.value || !to.value || !amount.value || !receiver.value)
            return [];
        if (typeof from.value !== 'string' || typeof receiver.value !== 'string')
            return [];
        return [
            {
                address: from.value,
                toSpend: [
                    {
                        token: to.value,
                        amount: amount.value,
                    },
                ],
                toReceive: [],
            },
            {
                address: receiver.value,
                toSpend: [],
                toReceive: [
                    {
                        token: to.value,
                        amount: amount.value,
                    },
                ],
            },
        ];
    },
});
